import { Box, Button, ButtonGroup, IconButton, AppBar as MuiAppBar, Toolbar } from '@material-ui/core';
import { Menu, MenuOpen } from '@material-ui/icons';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';

import BIServiceCRM from 'assets/icons/svg/BIServiceCRM';
import { USER_OPERATIONS } from 'helper';
import { BRAND } from 'theme';
import { RootState } from 'interfaces';
import { path as PageApplicationNewPath } from 'pages/PageApplicationNew';
import AcceptCallButton from './AcceptCallButton';
import AppBarMenu from './AppBarMenu';
import NotificationsButton from './NotificationsButton';
import UserAvatarButton from './UserAvatarButton';
import CreateCheckListButton from './CreateCheckListButton';
import EnvBadge, { ENV_COLOR } from './EnvBadge';
import SibeBarMenu from './SibeBarMenu';

const AppBar = () => {
  const operations = useSelector((state: RootState) => state.operations);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  return (
    <>
      <Box sx={{ height: 50 }}>
        <MuiAppBar
          position="fixed"
          style={{
            padding: 0,
            backgroundColor: BRAND.ink,
            // Полоска среды внутри шапки: высота не меняется, подложка под шапку остаётся 50px
            boxShadow: ENV_COLOR ? `inset 0 3px 0 ${ENV_COLOR}` : undefined,
          }}
        >
          <Toolbar
            style={{
              gridGap: 16,
              minHeight: 50,
              maxWidth: '100%',
              alignItems: 'center',
              position: 'relative',
              zIndex: 1,
            }}
          >
            <IconButton
              onClick={() => setIsDrawerOpen(!isDrawerOpen)}
              edge="start"
              size="small"
              color="inherit"
              aria-label="Боковое меню"
            >
              {isDrawerOpen ? <MenuOpen /> : <Menu />}
            </IconButton>

            <NavLink to="/" aria-label="Домашняя страница" style={{ display: 'inline-flex', alignItems: 'center' }}>
              <BIServiceCRM />
            </NavLink>

            <EnvBadge />

            <ButtonGroup size="small" variant="contained" style={{ color: 'white' }}>
              {operations.includes(USER_OPERATIONS.APP_SAVE) && (
                <Button
                  style={{ backgroundColor: '#0065FF', color: 'inherit' }}
                  variant="contained"
                  to={PageApplicationNewPath}
                  component={NavLink}
                >
                  Создать
                </Button>
              )}

              {operations.includes(USER_OPERATIONS.TAKE_A_CALL) && <AcceptCallButton />}
              {operations.includes(USER_OPERATIONS.CHECKLIST_VIEW) && <CreateCheckListButton />}
              {/* SERVICE-5222: кнопка «Закрыть» скрыта по просьбе бизнеса, функционал сохранён */}
            </ButtonGroup>

            <AppBarMenu />

            <NotificationsButton />
            <UserAvatarButton />
          </Toolbar>
        </MuiAppBar>
      </Box>

      <SibeBarMenu open={isDrawerOpen} onClose={() => setIsDrawerOpen(false)} />
    </>
  );
};

export default AppBar;
